import LoadingPage from "@/pages/common/LoadingPage";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";

interface AuthenticationGuardProps {
  component: React.ComponentType<any>;
  returnTo?: string;
}

export const AuthenticationGuard = ({
  component,
  returnTo,
}: AuthenticationGuardProps) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingPage />
      </div>
    ),
    loginOptions: returnTo ? { appState: { returnTo } } : undefined,
  });

  return <Component />;
};
